import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { UserManagementService } from '../../services/user-management.service';

@Component({
    selector: 'app-control-de-accesos',
    templateUrl: './control-de-accesos.component.html',
    styleUrls: ['./control-de-accesos.component.scss'],
    standalone: false
})
export class ControlDeAccesosComponent implements OnInit {

  DateFilterType = DateFilterTypes;
  public roleForm: UntypedFormGroup;

  constructor(
    private _dialogRef: MatDialogRef<ControlDeAccesosComponent>,
    private _userManagementService: UserManagementService,
    private _sharedService: SharedService,
    private _fileExportService: FileExportService,
    private _pageLoaderService: PageLoaderService,
    public _fb: UntypedFormBuilder) {
    this.createRoleForm();
  }

  ngOnInit(): void {

  }

  createRoleForm() {
    this.roleForm = this._fb.group({
      DateFrom: ['', Validators.required],
      DateTo: ['', Validators.required],
    });
  }

  public getFormControl(formControlName: string): UntypedFormControl {
    return this.roleForm.get(formControlName) as UntypedFormControl;
  }

  public setFilterValues(filterType: string, data: Date = null): void {
    switch (filterType) {
      case 'commonDateFrom':
        this.roleForm.patchValue({ DateFrom: DateHelper.getUTCDateString(data) });
        break;
      case 'commonDateTo':
        this.roleForm.patchValue({ DateTo: DateHelper.getUTCDateString(data) });
        break;
      default:
        break;
    }
  }

  submit() {
    this.roleForm.markAllAsTouched();
    if (this.roleForm.valid) {
      this.getControlDeAccesosFile();
    }
  }

  cancel() {
    this._dialogRef.close();
  }



  getControlDeAccesosFile() {
    this._pageLoaderService.ShowPageLoader();
    this._sharedService.ShowSnackBar('El archivo se descargará en breve', 'Okay', 2000);
    this._userManagementService.getControlDeAccesosFile(this.roleForm.value.DateFrom, this.roleForm.value.DateTo).subscribe(res => {
      if (res.code === 0 && res.result.file !== null && res.result.file !== undefined) {
        this._fileExportService.DownloadFile(res.result.file, res.result.fileName);
        this._dialogRef.close();
      } else {
        this._sharedService.ShowSnackBar('Proceso fallido', 'Okay', 2000);
      }
      this._pageLoaderService.HidePageLoader();
    }, error => {
      this._sharedService.ShowSnackBar('Proceso fallido');
      console.error(error);
      this._pageLoaderService.HidePageLoader();
    });
  }

}
